import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { cleanDescription, formatDate } from '../shared';
import { FilterSettings } from '../../projects/project-filters/filter-settings';

@Component({
  selector: 'master-schedule-single-project',
  templateUrl: './master-schedule-single-project.component.html',
  styleUrl: './master-schedule-single-project.component.scss',
  standalone: false,
})
export class MasterScheduleSingleProjectComponent {

  constructor(
    private readonly api: ApiService,
    private route: ActivatedRoute,
    private title: Title) {
  }

  public cleanDescription = cleanDescription;
  public formatDate = formatDate;

  @Input() public project: string = "";
  @Input() public projectNumberClickEnabled: boolean = true;
  @Output() public closeRequested = new EventEmitter<void>();
  public projectData: any = null;
  public filterSettings: FilterSettings = new FilterSettings();
  public showProjectCard: boolean = false;
  public projectCardPosition: { x: number, y: number } = { x: 0, y: 0 };

  ngOnInit() {
    this.filterSettings.startAtToday = false;

    if (this.project) {
      this.loadProject(this.project);
      return;
    }

    this.route.params.subscribe((p: any) => {
      this.project = p['project'];
      this.loadProject(this.project);
    });
  }

  private loadProject(projectNumber: string) {
    this.title.setTitle(`${projectNumber} - Master Schedule`);
    this.api.MasterSchedule.GetMasterScheduleProject(projectNumber).subscribe((project: any) => {
      project.ItemDescription = this.cleanDescription(project.ItemDescription);
      project.PoDate = this.formatDate(project.PoDate);
      project.RequestedShipDate = this.formatDate(project.RequestedShipDate);
      project.AcknowledgedShipDate = this.formatDate(project.AcknowledgedShipDate);
      project.CurrentShipDate = this.formatDate(project.CurrentShipDate);
      this.projectData = project;
    });
  }
}
